export enum PaymentPlatform {
  Stripe = 1,
  Wise = 2,
  Transference = 3
};